import { render } from "./EmailReport.vue?vue&type=template&id=eb4b773a"
import script from "./EmailReport.vue?vue&type=script&lang=js"
export * from "./EmailReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__